import { render, staticRenderFns } from "./HistogramChart.vue?vue&type=template&id=dcd05a24&"
import script from "./HistogramChart.vue?vue&type=script&lang=js&"
export * from "./HistogramChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports